module.exports = __webpack_public_path__ + "static/media/France.fd58d248.png";